import { call, fork, put, take } from 'redux-saga/effects';
import {OpenDoorPayload, openDoor} from '../action/depotsCommands';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar, enqueueSuccessSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import {Api} from '../api';
import {onFetchDoorStatus} from './fetchDoorStatusFlow';
import Logger from '../common/logger';
import { Depot } from '../api/types';

export const onOpenDoor = function*(depotId: string, doorNumber: number, actorEmail?: string) {
    const depot: Depot = yield call(Api.getDepotByID, depotId);
    try {
        yield call(Api.openDoor, depotId, doorNumber, actorEmail);
        
        yield put(enqueueSuccessSnackbar({
            message: getI18n().t('snackbar.success.open_door', { depotName: depot.name, doorNumber }),
        }));

        yield fork(onFetchDoorStatus, depotId);
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.open_door', { depotName: depot.name, doorNumber }),
        }));
    }
};

export function* openDoorFlow() {
    while (true) {
        const action: Action<OpenDoorPayload> = yield take(openDoor.toString());

        yield fork(onOpenDoor, action.payload.depotId, action.payload.doorNumber, action.payload.actorEmail);
    }
}
